import React from 'react';
import { IConciergeEmbedChatData } from 'interfaces/concierge';
import { useConciergeEmbedChatData } from 'hooks/useConciergeEmbedChatData';
import LiveChat from 'components/Global/LiveChat/LiveChat';
import AiLiveChat from 'components/Global/AiLiveChat/AiLiveChat';

const ConciergeEmbedChat = (): JSX.Element => {
  const queryKey = `/platform/api/v1/concierge/embedded-chat`;
  const { status, data } = useConciergeEmbedChatData(queryKey);

  const conciergeEmbedChat: IConciergeEmbedChatData =
    data as IConciergeEmbedChatData;

  switch (status) {
    case 'error':
      return <></>;
    case 'success':
      if (data.featureToggles.conciergeAIChatEnabled)
        {
          return (
            <AiLiveChat data={conciergeEmbedChat.embeddedAiChatResponse} />
          );
        }
      return <LiveChat data={conciergeEmbedChat.embeddedChatResponse}
                        featureToggles={conciergeEmbedChat.featureToggles} />;
    default:
      return <></>;
  }
};

export default ConciergeEmbedChat;
